import { customDispatch } from "@affinity/Store/ServiceBase";
import { AffinityProduct, ProductModelX } from "@affinity/Store/StoreTypes";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { post } from "@insite/client-framework/Services/ApiService";
import { getPageStateByType } from "@insite/client-framework/Store/Data/Pages/PageSelectors";

// External parameters
export interface SetQuoteBasicDetailsParameters {
    selectedProduct: AffinityProduct,
    postcode: string,
    emailAddress: string,
    allowMarketing: boolean,
    token: string,
}

// Internal parameters
interface Props {
    selectedProduct: ProductModelX,
}

type HandlerType = Handler<SetQuoteBasicDetailsParameters, Props>;

const UpdateState: HandlerType = props => {
    const allowMarketing = props.parameter.allowMarketing;
    const postcode = props.parameter.postcode;
    const emailAddress = props.parameter.emailAddress;
    (props.dispatch as customDispatch)({
        type: "Affinity/GetQuote/BasicDetails/Set",
        selectedProduct: props.parameter.selectedProduct,
        postcode,
        emailAddress,
        allowMarketing,
    });
}

const Tracking: HandlerType = async (props) => {
    if(props.parameter.allowMarketing){
        await post("/api/v1/mailchimp/addmember", { token: props.parameter.token, email_address: props.parameter.emailAddress })
    }
}

const chain = [
    UpdateState,
    Tracking,
];

const createAccount = createHandlerChainRunner(chain, "SetQuoteBasicDetails");
export default createAccount;